import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Invoice, InvoiceCreate } from 'types';
import { client } from 'utils/api-client';

export default function useCreateInvoice(): UseMutationResult<
  AxiosResponse<Invoice>,
  AxiosError<ErrorMessage>,
  InvoiceCreate
> {
  const queryClient = useQueryClient();

  const createInvoice = (invoice: InvoiceCreate): Promise<AxiosResponse<Invoice>> => {
    return client.post('invoices/', invoice);
  };

  return useMutation(createInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries('invoices');
    },
    onError: () => {
      queryClient.invalidateQueries('paymentMethods');
    },
  });
}
